export var POPOVER_ALIGN_CONFIG = {
  offset: [0, -10]
};